export interface RebetDrawRef {
  draw_id?: number
  event_id?: number
  draw_date?: string
}

export interface UpcomingDrawOption {
  draw_date: string
  cutoff?: string
  event_id: number
}

/**
 * Map a historical wager draw onto the current upcoming-draws list (same event or same draw time).
 */
export function resolveRebetDraws(
  game: RebetDrawRef,
  availableDraws: UpcomingDrawOption[]
): UpcomingDrawOption[] {
  if (!availableDraws.length) return []

  const targetEventId = Number(game.event_id ?? game.draw_id)
  if (Number.isFinite(targetEventId) && targetEventId > 0) {
    const byId = availableDraws.find((draw) => draw.event_id === targetEventId)
    if (byId) return [byId]
  }

  if (game.draw_date) {
    const targetMs = Date.parse(game.draw_date)
    if (!Number.isNaN(targetMs)) {
      const byDate = availableDraws.find((draw) => {
        const drawMs = Date.parse(draw.draw_date)
        return !Number.isNaN(drawMs) && Math.abs(drawMs - targetMs) < 60_000
      })
      if (byDate) return [byDate]
    }
  }

  return []
}
